import React from "react"
import ReportDivisions from "./fields/ReportDivisions"
import ReportFacilities from "./fields/ReportFacilities"
import ReportVendors from "./fields/ReportVendors"

export default function Exception() {
    // Division
    // Facility
    // Utility Company (Vendors)
    return (
        <div>
            <ReportDivisions />
            <ReportFacilities />
            <ReportVendors />
        </div>
    )
}
